var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isAheadClient)?_c(_setup.AheadBusinessClientNav):(_setup.isPeraltaClient)?_c(_setup.PeraltaClientNav):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }